var wrapElement = function wrapElement(element) {
  var wrapperTag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
  var wrapperClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'wrapper';
  if (!element) return;
  var wrapper = document.createElement(wrapperTag);
  wrapper.classList.add(wrapperClass);
  element.parentNode.insertBefore(wrapper, element);
  wrapper.appendChild(element);
};
export var initScrollableTableWithinRichText = function initScrollableTableWithinRichText(block) {
  if (!block) {
    throw new Error('Table selector is not passed as a parameter to function.');
  }
  Array.from(block.querySelectorAll('table')).forEach(function (table) {
    wrapElement(table, 'div', 'table-scrollable');
  });
};